import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '新浪保险之星',
      keepAlive: true
    }
  },
  {
    path: '/user-detail',
    name: 'UserDetail',
    component: () => import('@/views/userDetail/index.vue'),
    meta: {
      title: '新浪保险之星'
    }
  }
]

const router = createRouter({
  history: createWebHistory('/insurance-star-app'),
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }
    return ({ left: 0, top: 0 })
  }
})

export default router
